import { Injectable } from '@angular/core';
import {
  CompaniesClient,
  CompanyViewModel,
  CreateCompanyCommand,
  CreateFillSiteCommand,
  CreateQualifiedPersonCommand,
  CreateSourceSiteCommand,
  EditCompanyCommand,
  EditFillSiteCommand,
  EditQualifiedPersonCommand,
  EditSourceSiteCommand,
  FillSitesClient,
  FillSiteViewModel,
  LegalEntitiesClient,
  QualifiedPersonsClient,
  SourceSitesClient,
  SourceSiteViewModel,
  TermsAndConditionsClient,
  TermsAndConditionsViewModelResultResponse,
  UsersClient
} from '@services/cleanfill-api/cleanfill-api.generated';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpRegistrationService {
  constructor(
    private companiesClient: CompaniesClient,
    private sourceSiteClient: SourceSitesClient,
    private fillSiteClient: FillSitesClient,
    private legalEntitiesClient: LegalEntitiesClient,
    private qpClient: QualifiedPersonsClient,
    private usersClient: UsersClient,
    private termsAndConditionsClient: TermsAndConditionsClient
  ) {}

  userAcceptTerm(uniqueId: string): Observable<void> {
    return this.usersClient.userAcceptTerm(uniqueId, new Date().getTimezoneOffset().toString());
  }

  getTermsAndConditions():Observable<TermsAndConditionsViewModelResultResponse> {
    return this.termsAndConditionsClient.termsAndConditions(undefined);
  }

  createCompany(command: CreateCompanyCommand): Observable<CompanyViewModel> {
    return this.companiesClient.createCompany(new Date().getTimezoneOffset().toString(), command);
  }

  getCompany(uniqueId: string): Observable<CompanyViewModel> {
    return this.companiesClient.getCompanyDetail(uniqueId, new Date().getTimezoneOffset().toString());
  }

  editCompany(uniqueId: string, command: EditCompanyCommand): Observable<void> {
    return this.companiesClient.editCompany(uniqueId, new Date().getTimezoneOffset().toString(), command);
  }

  deleteCompany(uniqueId: string): Observable<void> {
    return this.companiesClient.deleteCompany(uniqueId, new Date().getTimezoneOffset().toString());
  }

  createSourceSite(command: CreateSourceSiteCommand): Observable<SourceSiteViewModel> {
    return this.sourceSiteClient.createSourceSite(new Date().getTimezoneOffset().toString(), command);
  }

  getSourceSite(uniqueId: string): Observable<SourceSiteViewModel> {
    return this.sourceSiteClient.getSourceSiteDetail(uniqueId, new Date().getTimezoneOffset().toString());
  }

  editSourceSite(uniqueId: string, command: EditSourceSiteCommand): Observable<void> {
    return this.sourceSiteClient.editSourceSite(uniqueId, new Date().getTimezoneOffset().toString(), command);
  }
  deleteSourceSite(uniqueId: string): Observable<void> {
    return this.sourceSiteClient.deleteSourceSite(uniqueId, new Date().getTimezoneOffset().toString());
  }

  getSourceSiteAttachments(uniqueId: string) {
    return this.sourceSiteClient.getSourceSiteAttachmentDetail(uniqueId, new Date().getTimezoneOffset().toString());
  }

  createFillSite(command: CreateFillSiteCommand): Observable<FillSiteViewModel> {
    return this.fillSiteClient.createFillSite(new Date().getTimezoneOffset().toString(), command);
  }

  getFillSite(uniqueId: string): Observable<FillSiteViewModel> {
    return this.fillSiteClient.getFillSiteDetails(uniqueId, new Date().getTimezoneOffset().toString());
  }

  editFillSite(uniqueId: string, command: EditFillSiteCommand): Observable<void> {
    return this.fillSiteClient.editFillSite(uniqueId, new Date().getTimezoneOffset().toString(), command);
  }
  deleteFillSite(uniqueId: string): Observable<void> {
    return this.fillSiteClient.deleteFillSite(uniqueId, new Date().getTimezoneOffset().toString());
  }

  getFillSiteAttachments(uniqueId: string) {
    return this.fillSiteClient.getFillSiteAttachmentDetail(uniqueId, new Date().getTimezoneOffset().toString());
  }
  createQualifiedPerson(command: CreateQualifiedPersonCommand) {
    return this.qpClient.createQualifiedPerson(new Date().getTimezoneOffset().toString(), command);
  }

  getQualifiedPerson(uniqueId: string) {
    return this.qpClient.getQualifiedPersonDetail(uniqueId, new Date().getTimezoneOffset().toString());
  }

  editQualifiedPerson(uniqueId: string, command: EditQualifiedPersonCommand) {
    return this.qpClient.editQualifiedPerson(uniqueId, new Date().getTimezoneOffset().toString(), command);
  }

  deleteQualifiedPerson(uniqueId: string) {
    return this.qpClient.deleteQualifiedPerson(uniqueId, new Date().getTimezoneOffset().toString());
  }
}
